// extracted by mini-css-extract-plugin
export default {"productGrid":"f1-z","centerLink":"g1-z","productSection":"h1-z","item":"i1-z","ctaButton":"j1-z"};